enum Align {
  Left = 'left',
  Right = 'right',
  Center = 'center'
}

interface TableHeaderType {
  title: string
  field: string
  align: Align
  collapsible?: boolean
}

export const columns: TableHeaderType[] = [
  {
    title: 'Employee type',
    field: 'employeeType',
    align: Align.Left
  },
  {
    title: 'Job title',
    field: 'jobTitle',
    align: Align.Left
  },
  {
    title: 'Status',
    field: 'status',
    align: Align.Left,
    collapsible: true
  },
  {
    title: 'Locations',
    field: 'locations',
    align: Align.Left,
    collapsible: true
  }
]
